import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { TThunkDispatch } from '../../../../types/redux';
import * as React from 'react';
import { changeSavedFilters } from '../../../../actions/filters';
import { useDebouncedCallback } from '../../hooks';
import { SQUARE_METER_SIGN } from '../../../../constants/symbols';
import { formatRangeValue } from '../../../../utils/formatters';
import { DropdownFilter } from '../../../../components/Filters';
import { DELAY } from '../../constants';
import { selectAreaFilters } from '../../../../selectors/filters';
import { useDropdownFilter } from '../../hooks/useDropdownFilter';
import { AreaDropdown } from '../../../../components/Filters/components/AreaDropdown';

export const AreaContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const { areaFrom, areaTo } = useSelector(selectAreaFilters, shallowEqual);

  const { filterRef, isOpen, tooltipOpened, onClick, onClose } = useDropdownFilter('area');

  const handleAreaFromChange = useDebouncedCallback(
    (value?: number) => {
      dispatch(changeSavedFilters({ areaFrom: value }, 'area'));
    },
    DELAY,
    [],
  );

  const handleAreaToChange = useDebouncedCallback(
    (value?: number) => {
      dispatch(changeSavedFilters({ areaTo: value }, 'area'));
    },
    DELAY,
    [],
  );

  const areaLabel = React.useMemo(
    () => formatRangeValue(areaFrom, areaTo, SQUARE_METER_SIGN) || 'Площадь',
    [areaFrom, areaTo],
  );

  return (
    <div ref={filterRef}>
      <DropdownFilter
        open={isOpen}
        label={areaLabel}
        openTooltip={tooltipOpened}
        onClose={onClose}
        onClick={onClick}
        dataName="Area"
        dropdownContent={
          <AreaDropdown
            tooltipOpened={tooltipOpened}
            areaFrom={areaFrom}
            areaTo={areaTo}
            filterRef={filterRef}
            onAreaFromChange={handleAreaFromChange}
            onAreaToChange={handleAreaToChange}
          />
        }
      />
    </div>
  );
};
